import { findGroup } from './cms';
import { UserStatus } from '@/api/auth';

enum VipGroups {
  VIP1 = 'VIP1',
  VIP2 = 'VIP2',
  VIP3 = 'VIP3',
}

export enum VipGroupName {
  GOLDEN = 'GOLD',
  PLATINUM = 'PLATINUM',
  DIAMOND = 'DIAMOND',
}

export const getUserVipGroup = (statuses?: UserStatus[]) => {
  if (!statuses) return;

  const findVipGroup = findGroup(statuses);

  if (findVipGroup(VipGroups.VIP3)) return VipGroupName.DIAMOND;
  if (findVipGroup(VipGroups.VIP2)) return VipGroupName.PLATINUM;
  if (findVipGroup(VipGroups.VIP1)) return VipGroupName.GOLDEN;

  return;
};
